import React, { memo } from "react";

const LoadingState = memo(
  ({ text = "Chargement en cours...", className = "py-8 text-center" }) => (
    <div className={className}>
      <div className="inline-block w-8 h-8 rounded-full border-b-2 border-blue-500 animate-spin"></div>
      <p className="mt-3 text-sm text-gray-600">{text}</p>
    </div>
  )
);

export default LoadingState;
